// extracted by mini-css-extract-plugin
export default {"search-box":"bb_Qz","search-box__input":"bb_QB form-control","search-box__icon":"bb_QC ml-2"};